import { useEffect, useState } from "react";
import { Gift, Copy, Share2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { publicApi } from "@/lib/api";
import { inr, fmtDate } from "@/lib/format";

export const ReferCard = ({ token }) => {
  const [d, setD] = useState(null);
  useEffect(() => { publicApi.get(`/${token}/referral`).then((r) => setD(r.data)).catch(() => {}); }, [token]);
  if (!d) return null;
  const link = `${window.location.origin}/join?ref=${d.code}`;
  const text = `I get fresh, preservative-free batter from ${d.business_name} delivered every morning. Join using my link: ${link}`;
  return (
    <div className="mt-4 rounded-2xl border border-[#F2B880] bg-[#FFF7EC] p-4" data-testid="portal-refer-card">
      <div className="flex items-center gap-2 font-display font-semibold text-[#0F382C]"><Gift className="h-5 w-5 text-[#D96B43]" />Refer a friend{d.reward > 0 ? `, get ${inr(d.reward)}` : ""}</div>
      <div className="mt-1 text-sm text-muted-foreground">
        {d.reward > 0 ? `When your friend joins Nex Fresh with your link, ${inr(d.reward)} is taken off your bill.` : "Share Nex Fresh with your friends."}
        {d.max > 0 && ` Up to ${d.max} friends.`}
      </div>
      <div className="mt-3 flex gap-2">
        <Button asChild className="flex-1 rounded-xl bg-[#25D366] hover:bg-[#20bd5a] text-white">
          <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" data-testid="refer-whatsapp-btn"><Share2 className="mr-2 h-4 w-4" />Share on WhatsApp</a>
        </Button>
        <Button variant="outline" className="rounded-xl" onClick={() => { navigator.clipboard?.writeText(link); toast.success("Link copied"); }} data-testid="refer-copy-btn"><Copy className="h-4 w-4" /></Button>
      </div>
      <div className="mt-2 truncate font-mono text-xs text-muted-foreground" data-testid="refer-link">{link}</div>
      {d.referrals.length > 0 && (
        <div className="mt-3 space-y-1 border-t border-[#F2B880]/50 pt-3 text-sm" data-testid="refer-list">
          <div className="font-semibold text-[#0F382C]">You earned {inr(d.total_earned)}</div>
          {d.referrals.map((r, i) => <div key={i} className="flex justify-between"><span>{r.friend_name} · {fmtDate(r.created_at)}</span><span className="font-mono">{r.reward > 0 ? inr(r.reward) : "-"}</span></div>)}
        </div>
      )}
    </div>
  );
};
